<ng-container *ngIf="!isDeviceDashboard">
  <app-filters-bar [filters]="anomaliesFilters" (filterSelected)="onFilterItemSelected($event)"
                   [cssColContainer]="'main-action-bar-col'"></app-filters-bar>
</ng-container>
